var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "train-home" },
    [
      _c("ui-header", {
        attrs: {
          "nav-num": 3,
          "user-info": _vm.userInfo,
          nav: _vm.nav,
          "login-url": _vm.loginUrl,
          "logout-url": _vm.logoutUrl,
          "register-url": _vm.registerUrl,
          "home-url": _vm.homeUrl,
          "ucenter-url": _vm.ucenterUrl
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "train-main" }, [
        _c("div", { staticClass: "train-tech" }, [
          _c(
            "div",
            {
              staticClass: "train-head",
              staticStyle: { "margin-bottom": "30px" }
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticStyle: { float: "right" } }, [
                _c("div", {
                  staticClass: "morebtn",
                  on: { click: _vm.techClick }
                })
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "tech-main",
              staticStyle: { width: "100%", overflow: "hidden" }
            },
            [
              _vm.bigTechItem.position != 1
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        width: "520px",
                        height: "320px",
                        float: "left",
                        background: "#D8D8D8"
                      }
                    },
                    [
                      _c("img", {
                        staticStyle: {
                          width: "213px",
                          height: "70px",
                          display: "block",
                          margin: "0 auto",
                          "margin-top": "125px"
                        },
                        attrs: { src: require("./images/ad.png") }
                      })
                    ]
                  )
                : _c(
                    "div",
                    {
                      staticStyle: {
                        width: "520px",
                        height: "320px",
                        float: "left",
                        position: "relative"
                      }
                    },
                    [
                      _c("img", {
                        staticStyle: {
                          cursor: "pointer",
                          position: "absolute"
                        },
                        attrs: { src: _vm.bigTechItem.attachment },
                        on: {
                          click: function($event) {
                            _vm.clickDetail(_vm.bigTechItem.videoUrl)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticStyle: {
                          position: "absolute",
                          width: "100%",
                          bottom: "0px",
                          height: "74px",
                          "font-size": "20px",
                          background: "rgba(0, 0, 0, 0.38)",
                          padding: "22px 20px 24px",
                          color: "#FFFFFF",
                          overflow: "hidden",
                          "white-space": "nowrap",
                          "text-overflow": "ellipsis"
                        },
                        domProps: { innerHTML: _vm._s(_vm.bigTechItem.title) }
                      })
                    ]
                  ),
              _vm._v(" "),
              _vm._l(_vm.otherTechItem, function(item, index) {
                return _c("div", [
                  index + 2 != item.position
                    ? _c(
                        "div",
                        {
                          staticClass: "smallTech",
                          staticStyle: { background: "#D8D8D8" }
                        },
                        [
                          _c("img", {
                            staticStyle: {
                              width: "142px",
                              height: "46px",
                              display: "block",
                              margin: "0 auto",
                              "margin-top": "52px"
                            },
                            attrs: { src: require("./images/ad.png") }
                          })
                        ]
                      )
                    : _c("div", { staticClass: "smallTechImg" }, [
                        _c("img", {
                          attrs: { src: item.attachment },
                          on: {
                            click: function($event) {
                              _vm.clickDetail(item.videoUrl)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: { innerHTML: _vm._s(item.title) }
                        })
                      ])
                ])
              })
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "train-fund" }, [
          _c(
            "div",
            {
              staticClass: "train-head",
              staticStyle: { "margin-bottom": "20px" }
            },
            [
              _vm._m(1),
              _vm._v(" "),
              _c("div", { staticStyle: { float: "right" } }, [
                _c("div", {
                  staticClass: "morebtn",
                  on: { click: _vm.fundClick }
                })
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "fund-main" },
            _vm._l(_vm.baseArr, function(item, index) {
              return _c("div", { staticClass: "fund-item" }, [
                index + 1 != item.position
                  ? _c("div", [_vm._m(2, true)])
                  : _c("div", [
                      _c(
                        "div",
                        {
                          staticClass: "fund-head",
                          staticStyle: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              _vm.clickDetail(item.videoUrl)
                            }
                          }
                        },
                        [
                          _c("img", { attrs: { src: item.attachment } }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "fund-title",
                            domProps: { innerHTML: _vm._s(item.title) }
                          })
                        ]
                      )
                    ])
              ])
            })
          )
        ]),
        _vm._v(" "),
        _vm.firArr.length != 0
          ? _c("div", { staticClass: "train-text" }, [
              _vm._m(3),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "course-part" },
                _vm._l(_vm.firArr, function(item, index) {
                  return _c("div", { staticClass: "course-item" }, [
                    _c("div", { staticClass: "course-head" }, [
                      _c("div", { staticClass: "head-short" }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "head-img",
                        attrs: { src: _vm.firPng[index] }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "head-line" })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "course-main" }, [
                      _c("div", {
                        staticClass: "course-title",
                        domProps: { innerHTML: _vm._s(item.category) }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "course-list" },
                        _vm._l(item.article, function(list, kay) {
                          return _c("div", {
                            domProps: { innerHTML: _vm._s(list.title) },
                            on: {
                              click: function($event) {
                                _vm.clickDetail(list.articleUrl)
                              }
                            }
                          })
                        })
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "more",
                          on: {
                            click: function($event) {
                              _vm.clickDetail(item.urlMore)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                            查看更多\n                        "
                          )
                        ]
                      )
                    ])
                  ])
                })
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "course-part",
                  staticStyle: { "border-bottom": "0", "margin-top": "30px" }
                },
                _vm._l(_vm.secArr, function(item, index) {
                  return _c("div", { staticClass: "course-item" }, [
                    _c("div", { staticClass: "course-head" }, [
                      _c("div", { staticClass: "head-short" }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "head-img",
                        attrs: { src: _vm.secPng[index] }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "head-line" })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "course-main" }, [
                      _c("div", {
                        staticClass: "course-title",
                        domProps: { innerHTML: _vm._s(item.category) }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "course-list" },
                        _vm._l(item.article, function(list, kay) {
                          return _c("div", {
                            domProps: { innerHTML: _vm._s(list.title) },
                            on: {
                              click: function($event) {
                                _vm.clickDetail(list.articleUrl)
                              }
                            }
                          })
                        })
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "more",
                          on: {
                            click: function($event) {
                              _vm.clickDetail(item.urlMore)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                            查看更多\n                        "
                          )
                        ]
                      )
                    ])
                  ])
                })
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("online-service"),
      _vm._v(" "),
      _c("img", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isShowToUp,
            expression: "isShowToUp"
          }
        ],
        staticClass: "toUp",
        attrs: { src: require("./images/toUp.png") },
        on: {
          click: function($event) {
            _vm.clickToUp()
          }
        }
      }),
      _vm._v(" "),
      _c("ui-footer", { staticStyle: { "margin-top": "80px" } })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { float: "left" } }, [
      _c(
        "div",
        {
          staticStyle: { "font-size": "18px", color: "#364983", height: "25px" }
        },
        [
          _vm._v(
            "\n                        视频培训-技术面\n                    "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            "letter-spacing": "0",
            float: "left",
            "font-size": "20px",
            color: "rgba(57,73,131,0.16)"
          }
        },
        [_vm._v("\n                        Technical\n                    ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { float: "left" } }, [
      _c(
        "div",
        {
          staticStyle: { "font-size": "18px", color: "#364983", height: "25px" }
        },
        [
          _vm._v(
            "\n                        视频培训-基础面\n                    "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            "letter-spacing": "0",
            float: "left",
            "font-size": "20px",
            color: "rgba(57,73,131,0.16)"
          }
        },
        [_vm._v("\n                        Fundamental\n                    ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "fund-head",
        staticStyle: { background: "#D8D8D8", "padding-top": "62px" }
      },
      [
        _c("img", {
          staticStyle: {
            width: "142px",
            height: "46px",
            margin: "0 auto",
            display: "block"
          },
          attrs: { src: require("./images/ad.png") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "train-head", staticStyle: { "margin-bottom": "15px" } },
      [
        _c("div", { staticStyle: { float: "left" } }, [
          _c(
            "div",
            {
              staticStyle: {
                "font-size": "18px",
                color: "#364983",
                height: "25px"
              }
            },
            [_vm._v("\n                        文字课程\n                    ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                "letter-spacing": "0",
                float: "left",
                "font-size": "20px",
                height: "28px",
                color: "rgba(57,73,131,0.16)"
              }
            },
            [_vm._v("\n                        Course\n                    ")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticStyle: { float: "right" } }, [
          _c("div", { staticClass: "pagebtn" })
        ])
      ]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e3f101ee", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e3f101ee","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/train/view/home/home.vue
// module id = 234
// module chunks = 1